module.exports = __webpack_public_path__ + "img/ring_y_skip_1_null@3x.c15f7702.png";